import React from "react";
import { Modal, Button } from "react-bootstrap";

const PedidoRealizadoModal = ({ show, handleClose, onEliminarYRehacer, onVerMiPedido }) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton style={{ backgroundColor: '#eab308', color: 'white' }}>
        <Modal.Title>⚠️ Ya tenés pedidos realizados</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center py-4">
        <p className="mb-3">Ya realizaste tu pedido para la semana próxima.</p>
        <p className="text-muted small">Podés ver tu pedido actual o eliminarlo todo para volver a empezar.</p>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-center gap-2">
        <Button 
          variant="primary" 
          onClick={onVerMiPedido}
          className="px-4"
        >
          📋 Ver Mi Pedido
        </Button>
        <Button 
          variant="danger" 
          onClick={onEliminarYRehacer}
          className="px-4"
        >
          🗑️ Borrar todo y volver a empezar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PedidoRealizadoModal;
